"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LogService_instances, _LogService__processResponseAndSendLog, _LogService__customFetch, _LogService_logError, _LogService_logInfo, _LogService__buildLogRequest;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogService = void 0;
const requestBuilder_1 = require("./requestBuilder");
class LogService {
    constructor(sysLevel) {
        _LogService_instances.add(this);
        this.errorLogsBuffer = [];
        this.infoLogsBuffer = [];
        _LogService__processResponseAndSendLog.set(this, async (res, requestURL, headers) => {
            if (res.status >= 400) {
                const error = new Error(`Server error fail, got ${res.status} response status (${res.statusText})`);
                this.addErrorLogToBuffer({
                    event: 'log-service_retry',
                    error: error,
                });
                throw error;
            }
            if (this.errorLogsBuffer.length > 0 && !requestURL.includes('log')) {
                await __classPrivateFieldGet(this, _LogService_instances, "m", _LogService_logError).call(this, headers);
            }
            return res;
        });
        _LogService__customFetch.set(this, async (fetchParams) => {
            const request = fetchParams.request;
            const headers = fetchParams.headers;
            try {
                const response = await fetch(request.url, request.request);
                await __classPrivateFieldGet(this, _LogService__processResponseAndSendLog, "f").call(this, response, request.url, headers);
                return response;
            }
            catch (error) {
                const err = error;
                this.addErrorLogToBuffer({
                    event: 'customFetch_error',
                    error: err,
                    message: `LogService: couldn't fetch response from ${request.url}.`,
                });
                return;
            }
        });
        this.sysLevel = sysLevel;
    }
    addErrorLogToBuffer(errorLog) {
        this.errorLogsBuffer.push(errorLog);
        return this;
    }
    addInfoLogToBuffer(infoLog) {
        this.infoLogsBuffer.push(infoLog);
        return this;
    }
    async sendAllLogs(headers) {
        const promises = [];
        if (this.errorLogsBuffer.length) {
            promises.push(__classPrivateFieldGet(this, _LogService_instances, "m", _LogService_logError).call(this, headers));
        }
        if (this.infoLogsBuffer.length) {
            promises.push(__classPrivateFieldGet(this, _LogService_instances, "m", _LogService_logInfo).call(this, headers));
        }
        return Promise.all(promises);
    }
}
exports.LogService = LogService;
_LogService__processResponseAndSendLog = new WeakMap(), _LogService__customFetch = new WeakMap(), _LogService_instances = new WeakSet(), _LogService_logError = async function _LogService_logError(headers) {
    const request = __classPrivateFieldGet(this, _LogService_instances, "m", _LogService__buildLogRequest).call(this, { error: this.errorLogsBuffer }, 'error', headers);
    const response = await __classPrivateFieldGet(this, _LogService__customFetch, "f").call(this, { request, headers });
    this.errorLogsBuffer = [];
    return response;
}, _LogService_logInfo = async function _LogService_logInfo(headers) {
    const request = __classPrivateFieldGet(this, _LogService_instances, "m", _LogService__buildLogRequest).call(this, { info: this.infoLogsBuffer }, 'info', headers);
    const response = await __classPrivateFieldGet(this, _LogService__customFetch, "f").call(this, { request, headers });
    this.infoLogsBuffer = [];
    return response;
}, _LogService__buildLogRequest = function _LogService__buildLogRequest(data, level, headers) {
    return (0, requestBuilder_1.requestBuilder)(this.sysLevel, { data, level }, false, headers);
};
